import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { CandleApi } from '@voladeum/client';
import { SLICE } from 'ducks/slice';

import { EMPTY_ARRAY } from '../../constants';

const initialState: CandleApi[] = EMPTY_ARRAY;

export const candlesSlice = createSlice({
  name: SLICE.CANDLES,
  initialState,
  reducers: {
    setCandles: (_state, action: PayloadAction<CandleApi[]>) => {
      return action.payload;
    },
    clearCandles: () => {
      return initialState;
    },
  },
});

export const { setCandles, clearCandles } = candlesSlice.actions;

export default candlesSlice.reducer;
